import { Platform, StyleSheet } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { useAppTheme } from '@context/ThemeContext';
import {
  ActionSheetOptions,
  useActionSheet as useExpoActionSheet,
} from '@expo/react-native-action-sheet';

const ACTION_SHEET_MARGIN = 5;

export function useActionSheet(
  options: ActionSheetOptions,
  callback: (i?: number) => void | Promise<void>
) {
  const { showActionSheetWithOptions } = useExpoActionSheet();
  const appTheme = useAppTheme();
  const insets = useSafeAreaInsets();

  const showActionSheet = () =>
    showActionSheetWithOptions(
      {
        ...options,
        ...Platform.select({
          default: {
            tintColor: appTheme.colors.text,
            showSeparators: true,
            containerStyle: {
              ...styles.containerStyle,
              backgroundColor: appTheme.colors.surface,
              borderRadius: appTheme.roundness,
              marginBottom: ACTION_SHEET_MARGIN + insets.bottom,
              maxWidth: appTheme.maxWidth,
            },
            separatorStyle: { backgroundColor: appTheme.colors.disabled },
          },
          ios: {
            userInterfaceStyle: appTheme.dark ? 'dark' : 'light',
          },
        }),
      },
      callback
    );

  return { showActionSheet };
}

const styles = StyleSheet.create({
  containerStyle: {
    alignSelf: 'center',
    margin: ACTION_SHEET_MARGIN,
    width: '97.5%',
  },
});
